import React from 'react'
import { Checkbox, Divider, Link, Text, makeStyles, mergeClasses, shorthands, tokens } from '@fluentui/react-components'
import { Grid } from '../common/grid/Grid'
import { GridItem } from '../common/grid/GridItem'
import { DemandSubType, Paragraph } from '../../api/schemas/schema'
import { ControlledTextInput } from '../common/inputs/TextInput'
import { ControlledDropDown } from '../common/inputs/Dropdown'
import { enumValuesToOptions } from '../../helpers/enumHelper'
import { Control, UseFieldArrayReturn } from 'react-hook-form'
import { LawFormValues } from '../../pages/SelectedLaw'
import { getNewSecurityDemand } from '../../helpers/lawHelper'
import { OpenRegular } from '@fluentui/react-icons'
import { t } from '../../i18n/i18n'
type ParagraphProps = {
   item: Paragraph
   control: Control<LawFormValues>
   selected: boolean
   selectedParagraphsFieldArray: UseFieldArrayReturn<LawFormValues, 'SelectedParagraphs', 'id'>
   isDisabled: boolean
}
const useStyles = makeStyles({
   marginTop: {
      marginTop: tokens.spacingVerticalM,
   },
   flex: {
      display: 'flex',
   },
   itemPosition: {
      ...shorthands.gap(tokens.spacingHorizontalS),
      alignItems: 'flex-start',
   },
   link: {
      '& span': {
         fontSize: tokens.fontSizeBase500,
      },
   },
})
export const ParagraphComponent = ({ item, control, selected, selectedParagraphsFieldArray, isDisabled }: ParagraphProps): JSX.Element => {
   const classes = useStyles()
   const { append, remove, fields } = selectedParagraphsFieldArray
   const isDemand = item.demandId !== null

   return (
      <Grid className={classes.marginTop}>
         <GridItem size="1/12">
            {isDemand && (
               <Link href={`/demands/${selectedParagraphsFieldArray.fields.find((paragraph) => paragraph.demandId === item.demandId)?.demandId}`}>
                  <div className={mergeClasses(classes.flex, classes.link)}>
                     <Text>{selectedParagraphsFieldArray.fields.find((paragraph) => paragraph.demandId === item.demandId)?.designation}</Text>
                     <OpenRegular fontSize={20} />
                  </div>
               </Link>
            )}
         </GridItem>

         <GridItem size="8/12" className={mergeClasses(classes.flex, classes.itemPosition)}>
            <Checkbox
               disabled={isDisabled}
               checked={selected}
               onChange={() => {
                  if (!selected) {
                     append({
                        ...getNewSecurityDemand(DemandSubType.Paragraph),
                        text: item.paragraphText,
                        paragraphId: item.id,
                        demandId: null,
                     })
                  } else {
                     remove(fields.findIndex((f) => f.paragraphId === item.id))
                  }
               }}
            />
            <section>
               <Text key={item.id}>{item.paragraphText}</Text>
               <br />
            </section>
         </GridItem>
         {selected && (
            <GridItem size="3/12">
               <ControlledTextInput
                  control={control}
                  label={t('DemandLevel')}
                  disabled
                  name={`SelectedParagraphs.${fields.findIndex((x) => x.paragraphId === item.id)}.level`}
               />
               <ControlledDropDown
                  disabled={isDisabled}
                  label={t('SubType')}
                  options={enumValuesToOptions(DemandSubType)}
                  control={control}
                  name={`SelectedParagraphs.${fields.findIndex((x) => x.paragraphId === item.id)}.subType`}
               />
            </GridItem>
         )}
         <GridItem size="12/12">
            <Divider />
         </GridItem>
      </Grid>
   )
}
